import * as React from 'react';

import Header from '../../../containers/ImportDesktopFile/Toast/Header';
import SubHeader from '../../../containers/ImportDesktopFile/Toast/SubHeader';
import List from '../../../containers/ImportDesktopFile/Toast/List';
import { Wrapper } from './styles';

interface ToastProps {
	isDisplayed: boolean;
}

const Toast = ({ isDisplayed }: ToastProps) => {
	const [isExpanded, setIsExpanded] = React.useState(true);

	return (
		<Wrapper isDisplayed={isDisplayed}>
			<Header
				isToastExpanded={isExpanded}
				onToggle={() => setIsExpanded(!isExpanded)}
			/>
			<SubHeader />
			{isExpanded && <List />}
		</Wrapper>
	);
};

export default Toast;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/ImportDesktopFile/Toast/index.tsx